import React, { useState, useEffect } from 'react';
import { campaignAPI, contactAPI, whatsappAPI } from '../api';
import { Link } from 'react-router-dom';

function Dashboard() {
  const [stats, setStats] = useState({
    campaigns: 0,
    contacts: 0,
    scheduled: 0
  });
  const [whatsappStatus, setWhatsappStatus] = useState(null);
  const [recentCampaigns, setRecentCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const [campaignsRes, contactsRes, scheduledRes, statusRes] = await Promise.all([
        campaignAPI.getAll(),
        contactAPI.getAll(),
        whatsappAPI.getScheduled(),
        whatsappAPI.getStatus()
      ]);

      setStats({
        campaigns: campaignsRes.data.length,
        contacts: contactsRes.data.length,
        scheduled: scheduledRes.data.filter(s => s.status === 'pending').length
      });

      setRecentCampaigns(campaignsRes.data.slice(0, 5));
      setWhatsappStatus(statusRes.data);
    } catch (error) {
      console.error('Error loading dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container"><div className="loading">Loading...</div></div>;
  }

  return (
    <div className="container">
      <h1 style={{ marginBottom: '20px' }}>Dashboard</h1>

      <div className="grid">
        <div className="stat-card">
          <h3>Total Campaigns</h3>
          <div className="stat-value">{stats.campaigns}</div>
        </div>
        <div className="stat-card">
          <h3>Total Contacts</h3>
          <div className="stat-value">{stats.contacts}</div>
        </div>
        <div className="stat-card">
          <h3>Scheduled Messages</h3>
          <div className="stat-value">{stats.scheduled}</div>
        </div>
        <div className="stat-card">
          <h3>WhatsApp Status</h3>
          <div className="stat-value">
            {whatsappStatus?.isConnected ? (
              <span style={{ color: '#25d366' }}>Connected</span>
            ) : (
              <span style={{ color: '#dc3545' }}>Disconnected</span>
            )}
          </div>
        </div>
      </div>

      <div className="card">
        <h2>Recent Campaigns</h2>
        {recentCampaigns.length === 0 ? (
          <div className="empty-state">
            <h3>No campaigns yet</h3>
            <p>Create your first campaign to get started!</p>
            <Link to="/campaigns">
              <button className="btn btn-primary">Create Campaign</button>
            </Link>
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {recentCampaigns.map(campaign => (
                  <tr key={campaign.id}>
                    <td>{campaign.name}</td>
                    <td>
                      <span className={`badge badge-${
                        campaign.status === 'draft' ? 'warning' : 
                        campaign.status === 'active' ? 'success' : 'info'
                      }`}>
                        {campaign.status}
                      </span>
                    </td>
                    <td>{new Date(campaign.created_at).toLocaleDateString()}</td>
                    <td>
                      <Link to={`/campaigns/${campaign.id}`}>
                        <button className="btn btn-secondary">View</button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
